import * as Yup from 'yup';

import { Column } from '~components/table-view';

import { SahCategory, SahService } from '~lookups/models';

const columnsFactory = (services: SahService[], category: SahCategory[]): Column[] => {
  const serviceOptions = services.map((service) => ({ id: service.id, name: service.name }));

  return [
    {
      id: 'service_id',
      header: 'Service Name',
      type: 'select',
      options: serviceOptions,
      isEditable: true,
      validation: Yup.mixed().required('Service is required'),
    },
    {
      // Display-only derived column. The dotted id keeps it out of create/update payloads
      // (filterRowFields skips dotted keys) and away from the real category_id row field.
      id: 'service.category_name',
      header: 'Category',
      type: 'text',
      isEditable: false,
      deriveValue: (row) => {
        const service = services.find((s) => s.id === row.service_id);
        return service ? (category.find((c) => c.id === service.category_id)?.name ?? '') : '';
      },
    },
    {
      id: 'start_date',
      header: 'Start Date',
      type: 'date',
      isEditable: true,
      validation: Yup.string().required('Start date is required'),
    },
    {
      id: 'end_date',
      header: 'End Date',
      type: 'date',
      isEditable: true,
      validation: Yup.string()
        .required('End date is required')
        .test('end-after-start', 'End date must be after start date', function (value) {
          const { start_date } = this.parent;
          if (!value || !start_date) return true;
          return new Date(value) >= new Date(start_date);
        }),
    },
  ];
};

export default columnsFactory;
